import { CommonModule, DecimalPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import {
  DxBoxModule,
  DxButtonGroupModule,
  DxButtonModule, DxCheckBoxModule, DxDataGridModule,
  DxDateBoxModule,
  DxDropDownBoxModule,
  DxDropDownButtonModule,
  DxFileManagerModule,
  DxFileUploaderModule,
  DxFilterBuilderModule,
  DxFormModule,
  DxListModule,
  DxLoadIndicatorModule,
  DxLoadPanelModule, DxLookupModule, DxNumberBoxModule, DxPopoverModule, DxPopupModule,
  DxProgressBarModule, DxRadioGroupModule, DxScrollViewModule, DxSelectBoxModule,
  DxSortableModule,
  DxSwitchModule,
  DxTabPanelModule, DxTagBoxModule, DxTemplateModule,
  DxTextAreaModule,
  DxTextBoxModule,
  DxToolbarModule,
  DxTooltipModule,
  DxTreeListModule
} from "devextreme-angular";
import { NgxBarcode6Module } from 'ngx-barcode6';
import { DocumentListComponent } from '../../components/document-list/document-list.component';
import { FileManagerComponent } from '../../components/file-manager/file-manager.component';
import { TraitementStatusComponent } from '../../components/traitement-status/traitement-status.component';
import { ArticleDetailBonListComponent } from './article-detail-bon-list/article-detail-bon-list.component';
import { ArticleListDatagridComponent } from './article-list-datagrid/article-list-datagrid.component';
import { AuditPisteComponent } from './audit-piste/audit-piste.component';
import { BackButton } from './back-button/back-button.component';
import { BoSettingsFormComponent } from './bo-settings-form/bo-settings-form.component';
import { BonAchatDatagridComponent } from './bon-achat-datagrid/bon-achat-datagrid.component';
import { BonListParArticleComponent } from './bon-list-par-article/bon-list-par-article.component';
import { AllBonListComponent } from "./bon/all-bon-list/all-bon-list.component";
import { BonListTousSiteGlobaleDatagridComponent } from "./bon/all-bon-list/bon-list-tous-site-globale-datagrid/bon-list-tous-site-globale-datagrid.component";
import { BonDetailArticlesNonPrevusComponent } from './bon/bon-detail/bon-detail-articles-non-prevus/bon-detail-articles-non-prevus.component';
import { BonDetailComptageComponent } from './bon/bon-detail/bon-detail-comptage/bon-detail-comptage.component';
import { BonDetailEnteteComponent } from './bon/bon-detail/bon-detail-entete/bon-detail-entete.component';
import { BonDetailGestionDesColisComponent } from './bon/bon-detail/bon-detail-gestion-des-colis/bon-detail-gestion-des-colis.component';
import { BonDetailIntegrationBackOfficeComponent } from './bon/bon-detail/bon-detail-integration-back-office/bon-detail-integration-back-office.component';
import { BonDetailLieuStockageComponent } from './bon/bon-detail/bon-detail-lieu-stockage/bon-detail-lieu-stockage.component';
import { BonDetailLignesComponent } from './bon/bon-detail/bon-detail-lignes/bon-detail-lignes.component';
import { BonDetailNumeroSerieComponent } from './bon/bon-detail/bon-detail-numero-serie/bon-detail-numero-serie.component';
import { BonDetailParametresComponent } from './bon/bon-detail/bon-detail-parametres/bon-detail-parametres.component';
import { BonDetailPhotosComponent } from './bon/bon-detail/bon-detail-photos/bon-detail-photos.component';
import { BonDetailTracabiliteComponent } from './bon/bon-detail/bon-detail-tracabilite/bon-detail-tracabilite.component';
import { BonDetailComponent } from './bon/bon-detail/bon-detail.component';
import { BonListGlobaleDatagridComponent } from './bon/bon-list-globale-datagrid/bon-list-globale-datagrid.component';
import { BonListLieuStockageDatagridComponent } from './bon/bon-list-lieu-stockage-datagrid/bon-list-lieu-stockage-datagrid.component';
import { BonListComponent } from './bon/bon-list/bon-list.component';
import { CellCodebarreLinkComponent } from './cell-codebarre-link/cell-codebarre-link.component';
import { CellEcartComponent } from './cell-ecart/cell-ecart.component';
import { CodeBarreArticleDetailComponent } from './code-barre-article-detail/code-barre-article-detail.component';
import { ContactListComponent } from './contact-list/contact-list.component';
import { BackButtonDirective } from './directives/backbutton.directive';
import { StorageDirective } from './directives/storage.directive';
import { DocumentLogistiqueEnteteComponent } from './document-logistique-entete/document-logistique-entete.component';
import { DossierListSubComponent } from './dossier-list/dossier-list-sub.component';
import { FluxEtapeIconComponent } from './flux-etape-icon/flux-etape-icon.component';
import { FluxEtapePossibleListComponent } from './flux-etape-possible-list/flux-etape-possible-list.component';
import { FluxHistoriqueListComponent } from './flux-historique-list/flux-historique-list.component';
import { FluxStatutIconComponent } from './flux-statut-icon/flux-statut-icon.component';
import { GererGridStateComponent } from './gerer-grid-state/gerer-grid-state.component';
import { GestionCaracteristiquesComponent } from './gestion-caracteristiques/gestion-caracteristiques.component';
import { GestionTerminauxComponent } from './gestion-terminaux/gestion-terminaux.component';
import { LieuStockageArticleComponent } from "./lieux-stockage/lieu-stockage-article/lieu-stockage-article.component";
import { LieuStockageTreeListComponent } from './lieux-stockage/lieu-stockage-tree-list/lieu-stockage-tree-list.component';
import { LotStockageDatagridComponent } from './lot-stockage-datagrid/lot-stockage-datagrid.component';
import { LotStockageMagasinDatagridComponent } from './lot-stockage-magasin-datagrid/lot-stockage-magasin-datagrid.component';
import { MagasinPieceNatureDatagridComponent } from './magasin-piece-nature-datagrid/magasin-piece-nature-datagrid.component';
import { MouvementStockDatagridComponent } from './mouvement-stock-datagrid/mouvement-stock-datagrid.component';
import { MouvementStockViewComponent } from './mouvement-stock-view/mouvement-stock-view.component';
import { NotesListComponent } from './notes-list/notes-list.component';
import { ComptageDetailComponent } from './numera/comptage-detail/comptage-detail.component';
import { ObjecttypeEditionPossibleListComponent } from './objecttype-edition-possible-list/objecttype-edition-possible-list.component';
import { OperationCommercialeDetailListComponent } from './operation-commerciale-detail-list/operation-commerciale-detail-list.component';
import { OperationCommercialeDetailsSeuilsComponent } from './operation-commerciale-detail-list/operation-commerciale-details-seuils/operation-commerciale-details-seuils/operation-commerciale-details-seuils.component';
import { OperationsCommercialesPourArticleDetailComponent } from './operations-commerciales-pour-article-detail/operations-commerciales-pour-article-detail.component';
import { PaginationComponent } from './pagination/pagination.component';
import { ParametrageGrilleComponent } from './parametrage-grille/parametrage-grille.component';
import { PartenaireFretLocalSettingsFormComponent } from './partenaire-fret-local-settings-form/partenaire-fret-local-settings-form.component';
import { PartenaireInformationsCardComponent } from './partenaire-informations-card/partenaire-informations-card.component';
import { InternationalisationPipe } from './pipes/internationalisation.pipe';
import { PopupImportFichierExcelComponent } from './popup-import-fichier-excel/popup-import-fichier-excel.component';
import { ReferenceService } from './references/references.service';
import { RegistreNumeroSerieListComponent } from './registre-numero-serie-list/registre-numero-serie-list.component';
import { ReglementCreationComponent } from './reglement-creation/reglement-creation.component';
import { ResetGridStateComponent } from './reset-grid-state/reset-grid-state.component';
import { StockViewComponent } from './stock-view/stock-view.component';
import { TooltipDateCreationComponent } from './tooltip-date-creation/tooltip-date-creation.component';
import { TpvSettingsFormComponent } from './tpv-settings-form/tpv-settings-form.component';
import { ValorisationStockComponent } from "./valorisation-stock/valorisation-stock.component";
import { VoyageFretLocalSettingsFormComponent } from './voyage-fret-local-settings-form/voyage-fret-local-settings-form.component';
import { XmlPipe } from './xml-pipe/xml.pipe';

@NgModule({
  declarations: [
    CellCodebarreLinkComponent,
    BackButton,
    ComptageDetailComponent,
    CellEcartComponent,
    XmlPipe,
    GestionTerminauxComponent,
    ContactListComponent,
    ParametrageGrilleComponent,
    InternationalisationPipe,
    MagasinPieceNatureDatagridComponent,
    MouvementStockDatagridComponent,
    LotStockageDatagridComponent,
    StockViewComponent,
    ValorisationStockComponent,
    MouvementStockViewComponent,
    AllBonListComponent,
    BonListComponent,
    BonListGlobaleDatagridComponent,
    BonListLieuStockageDatagridComponent,
    BonDetailComponent,
    BonDetailEnteteComponent,
    BonDetailLieuStockageComponent,
    BonDetailLignesComponent,
    BonDetailTracabiliteComponent,
    OperationCommercialeDetailListComponent,
    OperationCommercialeDetailsSeuilsComponent,
    OperationsCommercialesPourArticleDetailComponent,
    TpvSettingsFormComponent,
    AuditPisteComponent,
    CodeBarreArticleDetailComponent,
    ArticleListDatagridComponent,
    DossierListSubComponent,
    LotStockageMagasinDatagridComponent,
    VoyageFretLocalSettingsFormComponent,
    PartenaireFretLocalSettingsFormComponent,
    DocumentListComponent,
    FileManagerComponent,
    FluxEtapePossibleListComponent,
    BonDetailGestionDesColisComponent,
    LieuStockageTreeListComponent,
    FluxHistoriqueListComponent,
    BonDetailNumeroSerieComponent,
    BonListParArticleComponent,
    NotesListComponent,
    DocumentLogistiqueEnteteComponent,
    FluxStatutIconComponent,
    FluxEtapeIconComponent,
    BonDetailComptageComponent,
    RegistreNumeroSerieListComponent,
    StorageDirective,
    BackButtonDirective,
    TooltipDateCreationComponent,
    ArticleDetailBonListComponent,
    BonDetailParametresComponent,
    ResetGridStateComponent,
    GestionCaracteristiquesComponent,
    BoSettingsFormComponent,
    PopupImportFichierExcelComponent,
    BonAchatDatagridComponent,
    ObjecttypeEditionPossibleListComponent,
    BonListTousSiteGlobaleDatagridComponent,
    LieuStockageArticleComponent,
    ReglementCreationComponent,
    PartenaireInformationsCardComponent,
    GererGridStateComponent,
    PaginationComponent,
    BonDetailPhotosComponent,
    BonDetailArticlesNonPrevusComponent,
    BonDetailIntegrationBackOfficeComponent,
    TraitementStatusComponent
  ],
  imports: [
    CommonModule,

    // Devextreme
    DxDataGridModule, DxTemplateModule, DxProgressBarModule,
    DxPopupModule, DxButtonModule, DxDropDownButtonModule,
    DxScrollViewModule, DxTooltipModule, DxCheckBoxModule,
    DxFormModule, DxSelectBoxModule, DxRadioGroupModule,
    DxTabPanelModule, DxLookupModule, DxBoxModule, DxNumberBoxModule,
    DxLoadPanelModule, DxTagBoxModule, DxSwitchModule, DxPopoverModule,
    DxFileUploaderModule, DxLoadIndicatorModule, DxTreeListModule,
    DxTextBoxModule, DxListModule, DxTextAreaModule, DxDateBoxModule,
    DxTextBoxModule, DxToolbarModule, DxButtonGroupModule, DxFilterBuilderModule,
    DxDropDownBoxModule, DxSortableModule, DxFileManagerModule,
    // end Devextreme
    RouterModule,
    NgxBarcode6Module,
    FormsModule,
    DecimalPipe
  ],
  exports: [
    CellCodebarreLinkComponent,
    BackButton,
    ComptageDetailComponent,
    CellEcartComponent,
    XmlPipe,
    GestionTerminauxComponent,
    ContactListComponent,
    ParametrageGrilleComponent,
    InternationalisationPipe,
    MagasinPieceNatureDatagridComponent,
    MouvementStockDatagridComponent,
    LotStockageDatagridComponent,
    StockViewComponent,
    MouvementStockViewComponent,
    BonListComponent,
    BonListGlobaleDatagridComponent,
    BonListLieuStockageDatagridComponent,
    BonDetailComponent,
    OperationCommercialeDetailListComponent,
    OperationCommercialeDetailsSeuilsComponent,
    OperationsCommercialesPourArticleDetailComponent,
    TpvSettingsFormComponent,
    AuditPisteComponent,
    CodeBarreArticleDetailComponent,
    ArticleListDatagridComponent,
    VoyageFretLocalSettingsFormComponent,
    PartenaireFretLocalSettingsFormComponent,
    DocumentListComponent,
    FileManagerComponent,
    FluxEtapePossibleListComponent,
    BonDetailGestionDesColisComponent,
    BonDetailComptageComponent,
    LieuStockageTreeListComponent,
    FluxHistoriqueListComponent,
    BonListParArticleComponent,
    NotesListComponent,
    DocumentLogistiqueEnteteComponent,
    FluxStatutIconComponent,
    FluxEtapeIconComponent,
    RegistreNumeroSerieListComponent,
    StorageDirective,
    BackButtonDirective,
    TooltipDateCreationComponent,
    ArticleDetailBonListComponent,
    BonDetailParametresComponent,
    BonDetailTracabiliteComponent,
    ResetGridStateComponent,
    GestionCaracteristiquesComponent,
    BonAchatDatagridComponent,
    ObjecttypeEditionPossibleListComponent,
    LieuStockageArticleComponent,
    DossierListSubComponent,
    ReglementCreationComponent,
    PartenaireInformationsCardComponent,
    GererGridStateComponent,
    PaginationComponent,
    BonDetailIntegrationBackOfficeComponent,
    TraitementStatusComponent
  ],
  providers: [
    ReferenceService,
    InternationalisationPipe,
    DecimalPipe
  ]
})
export class SharedModule { }
